import { inject, Pipe, PipeTransform } from '@angular/core';
import { EPriceType, LayoutProductType } from '@atlas-workspace/shared/models';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'includedCounterTooltipText',
  standalone: true,
})
export class IncludedCounterTooltipTextPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(type: LayoutProductType): string {
    if (type.product?.priceType === EPriceType.OnRequest) {
      return this.translateService.instant('Title.Extra_on_request');
    }

    if (!type.extraAmountEnabled) {
      return this.translateService.instant('Title.Extra_amount_disabled_tooltip', {
        qty: type.extraTotalAmount ?? 0,
      });
    }

    return this.translateService.instant('Title.Extra_info_tooltip_new', {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      DEFAULTVALUE:
        type.product?.priceType === EPriceType.Fixed
          ? type.quantity
          : type.product?.priceType === EPriceType.RunningMeter
            ? type.runLength
            : type.areaSize,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      VALUE: type.extraMaxTotalAmount || type.maxExtraAmount,
    });
  }
}
